import React from "react";
import { useRecoilValue } from "recoil";
import { fnolPageDeciderState } from "atoms/fnolPageDeciderState.atom";
import * as constants from "constants/PageNameConstants";
import TakingFnolForm from "pages/TakingFnolForm";
import FnolSubmissionComplete from "./FnolSubmissionComplete";

const PageDeciderViewer = () => {
  const stageState = useRecoilValue(fnolPageDeciderState);

  return (
    <>
      {stageState.stage === constants.TAKINGFNOL_PAGE ? <TakingFnolForm /> : null}
      {stageState.stage === constants.TAKINGFNOLSUBMIT_PAGE ? <FnolSubmissionComplete /> : null}
    </>
  );
};

export default PageDeciderViewer;
